import React, { Component, Fragment } from 'react';
import {currency_symbol} from '../../../../server/constants';
import {convertTwoDecimalPoint, _addNotificationError, allowNumberWithDecimalNegative, allowNumericWithdecimal} from '../../../../server/util'
var _ = require('lodash');
class PaymentModal extends Component {
    render() {
        return (
            <Fragment>
                <div className="modal-header row">
                    <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Add Payments</h4>
                    <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.props.closePaymentModel()}>X</button></div>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12">
                            <form name="frmPay" className="">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12">                                        
                                        <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                            <label htmlFor="payType">Payment Type</label>
                                            <select className="form-control" name="payType" value={this.props.payModalObject.paymentType} onChange={
                                                (e)=>{
                                                    let payObj=this.props.payModalObject;
                                                    payObj.paymentType=e.target.value;
                                                    this.props.onChangePaymentObj(payObj)
                                                }
                                            } >
                                                <option value='Cash'>Cash</option>
                                                <option value='Check'>Check</option>
                                                <option value='CreditCard'>Credit card</option>
                                            </select>                                            
                                        </div>
                                        { (this.props.payModalObject.paymentType!='Cash')?
                                        (<div className="form-group col-xs-3 col-sm-3 col-md-3">
                                            <label htmlFor="checkNumb">{this.props.payModalObject.paymentType==='Check'?'Check No':'Transaction No '}</label>
                                            <input type="text" className="form-control" name="checkNumb" maxLength="25" value={this.props.payModalObject.checkNumb}
                                            onChange={(e)=>{
                                                let payObj=this.props.payModalObject;
                                                    payObj.checkNumb=e.target.value;
                                                    this.props.onChangePaymentObj(payObj)
                                               }} />
                                        </div>
                                         
                                        ):null}
                                                                   
                                        </div>                                        
                                        </div>
                                        <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12">
                                        <table className="table table-payment-modal">
                                            <thead>
                                              <tr>
                                                <td>Name</td>
                                                <td style={{width:'30%'}}>Amount</td>
                                              </tr>
                                            </thead>
                                            <tbody style={{maxHeight:'300px',overflowY:'auto',display:'block'}}>
                                                {
                                                    this.props.payModalObject.paymentList.map((row,key)=>{
                                                        return (<tr>
                                                            <td>{row.fullName}</td>
                                                            <td>{currency_symbol()+' '+convertTwoDecimalPoint(row.pkgCost)}</td>
                                                        </tr>)

                                                    })
                                                }
                                                
                                            </tbody>
                                            <tfoot><tr>
                                                <td>Total Amount :</td>
                                                <td>{currency_symbol()+' '+convertTwoDecimalPoint(this.props.payModalObject.totalAmount||0.00)}</td></tr>
                                                {/* <td>{currency_symbol()+' '+convertTwoDecimalPoint(this.computAmount())}</td></tr> */}
                                            </tfoot>
                                        </table>
                                        </div>                                        
                                        </div>
                                            
                                                <div className="text-right">
                                                    <button type="button" className="btn btn-danger btn-xs"
                                                        onClick={() => this.props.closePaymentModel()}>
                                                            <i className="fa fa-times-circle"
                                                            style={{ margin: '0 0 0 5px' }}></i> Cancel
                                                    </button>
                                                    <button type="button" id="paySubmit" onClick={(e)=>{
                                                        this.props.onSubmitPayment(e);
                                                    }}
                                                        className="btn btn-success btn-xs">
                                                        <i className="fa fa-check-circle"
                                                        style={{ margin: '0 0 0 5px' }}></i> Submit
                                                    </button>
                                                </div>
                                           
                                        </form>
                                    </div>
                                </div>
                                </div>
                
            </Fragment>
        );
    }
}

export default PaymentModal;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManageBcAc/paymentModal.jsx